import React from 'react';
import { FaTimesCircle, FaRedo, FaHome } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';

const PaymentFailure = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get('user_id');

    return (
        <div className="min-h-screen bg-gradient-to-br from-red-50 to-indigo-100 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
                <div className="mb-6">
                    <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mx-auto">
                        <FaTimesCircle className="text-red-500 text-5xl" />
                    </div>
                </div>
                
                <h1 className="text-2xl font-bold text-gray-800 mb-2">Payment Failed!</h1>
                <p className="text-gray-600 mb-6">
                    Your payment could not be processed. Please try again.
                </p>
                
                <div className="space-y-3">
                    <button
                        onClick={() => navigate(`/payment-method?user_id=${userId}&amount=4000`)}
                        className="w-full bg-indigo-600 text-white py-2 rounded-lg hover:bg-indigo-700 transition flex items-center justify-center space-x-2"
                    >
                        <FaRedo />
                        <span>Try Again</span>
                    </button>
                    
                    <button
                        onClick={() => navigate('/')}
                        className="w-full bg-gray-500 text-white py-2 rounded-lg hover:bg-gray-600 transition flex items-center justify-center space-x-2"
                    >
                        <FaHome />
                        <span>Go to Home</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentFailure;